import styled, { CSSProperties } from 'styled-components';

type Props = {
  appearance?: 'border';
};

const Root = styled.dl<Props>`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  margin: 0;
  padding: ${({ theme }) => `${theme.spaces.l} ${theme.spaces.m}`};
  border-bottom: ${({ theme, appearance }) =>
    appearance === 'border'
      ? `1px solid ${theme.borderColors.default}`
      : 'none'};
`;

const Title = styled.dt``;

const Comment = styled.dd``;

export const CheckList = Object.assign(Root, { Title, Comment });
